import fetcher from '@api/fetchers';

/* eslint-disable import/prefer-default-export */
export const updateRecentSearchLog = (data) =>
  fetcher('plus_search/searchlogs', {
    requestType: 'POST',
    useSearchToken: true,
    body: data
  });
